import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { cl_router } from './router';
import './styles.css';

const cl_app = createApp(App);
cl_app.use(createPinia());
cl_app.use(cl_router);
cl_app.mount('#app');
